import { Transition } from '@headlessui/react'
import { ReactNode } from 'react'

export function SettingsContainer({
  showSettings,
  children,
}: {
  showSettings: boolean
  children: ReactNode
}) {
  const transitionConfigClass =
    'transition-translate duration-[200ms] ease-linear'
  const containerSizeClass = 'absolute h-[54px] w-[120px]'
  return (
    <Transition
      show={showSettings}
      enter={`${transitionConfigClass} ${containerSizeClass}`}
      enterFrom="translate-y-full bottom-0 right-0"
      enterTo="bottom-0 right-0"
      leave={`${transitionConfigClass} ${containerSizeClass}`}
      leaveFrom="bottom-0 right-0"
      leaveTo="translate-y-full bottom-0 right-0"
    >
      <span
        className={`${containerSizeClass} bottom-0 right-0 hidden sm:flex flex-col border-l-2 border-t-2 border-solid p-2 bg-white rounded-tl-[16px] border-acai-10`}
        onClick={(event) => {
          event.stopPropagation()
        }}
      >
        {children}
      </span>
    </Transition>
  )
}
